export const TEXT_INPUT = 'textinput'
export const RADIO_INPUT = 'radioinput'
export const DROPDOWN_INPUT = 'dropdown'
export const AUTOCOMPLETE_INPUT = 'autocomplete'
export const TEXTAREA_INPUT = 'textarea'
export const CHECKBOX_INPUT = 'checkboxinput'
export const SELECT_DROPDOWN_INPUT = 'selectdropdown'
export const REACT_AUTOSUGGEST_INPUT = 'reactautosuggest'
export const COMMON_DATE_PICKER = 'commondatepicker'
